import { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import useAuthentication from 'application/authentication/useAuthentication';
import { LoginCredentials } from 'types/authentication/login';
import Button from 'components/Button/Button';
import Input from 'components/Input/Text/Input';
import ThemeCheckBox from 'components/Input/CheckBox/ThemeCheckBox';
import './LogIn.scoped.scss';
import InfoBanner from 'components/InfoBanner/InfoBanner';

interface Props {
  children: React.ReactNode;
  color?: string;
  text: string;
  outlined: string;
  desperate: string;
  onClick: () => void;
}

const Login: React.FC<Props> = () => {
  const [crendetials, setCredentials] = useState<LoginCredentials>({ email: '', password: '' });
  const { login, error } = useAuthentication();
  const [emptyCrend, setEmptyCrend] = useState<boolean>(false);
  const [errMssg, setErrMssg] = useState('');
  const [infoBannerVisible, setInfoBannerVisible] = useState(true);

  const { t } = useTranslation('login');
  const hostname = 'demo.schoolify.ee';
  const windowHostname = window.location.hostname;
  const [didMount, setDidMount] = useState(false);

  function userLogin() {
    login(crendetials);
  }

  const handleEnterKey = event => {
    if (event.key === 'Enter') {
      userLogin();
    }
  };

  useEffect(() => {
    if (crendetials.email.length < 1 || crendetials.password.length < 1) setEmptyCrend(true);
    else setEmptyCrend(false);
  }, [crendetials]);
  useEffect(() => {
    setDidMount(true);
    return () => setDidMount(false);
  }, []);

  useEffect(() => {
    if (error) {
      if (error.includes('"email" must be a valid email')) setErrMssg(t('Invalid Email'));
      if (error.includes('Username and password do not match.')) setErrMssg(t('Wrong credentials'));
      if (error.includes('Account does not exist.')) setErrMssg(t('Wrong credentials'));
    } else {
      setErrMssg('');
    }
  }, [error, t]);

  const changeHandleBanner = () => {
    setInfoBannerVisible(!infoBannerVisible);
  };
  if (!didMount) {
    return null;
  }

  return (
    <div className="page section log-in-page flex">
      <div className="content flex column align-center">
        <div className="title-container">
          <div className="title" style={{ fontWeight: 'bolder' }}>
            {t('Log in')}
          </div>
        </div>

        <div className="vertical-separator" />

        {hostname === windowHostname && infoBannerVisible && (
          <InfoBanner handleBannerVisibility={changeHandleBanner} />
        )}

        <Input
          desperate
          placeholder="example@email.com"
          label={t('Username or Email')}
          onChange={value => setCredentials(prevState => ({ ...prevState, email: value }))}
          onKeyDown={handleEnterKey}
          type="text"
        />
        <div className="vertical-separator" />
        <div className="vertical-separator" />
        <Input
          placeholder={t('Enter your password')}
          label={t('Password')}
          desperate
          onChange={value => setCredentials(prevState => ({ ...prevState, password: value }))}
          onKeyDown={handleEnterKey}
          type="password"
        />
        <div className="helps flex align-center w-100">
          <div className="text-left">
            <ThemeCheckBox label={t('Keep me logged in')} checked onChange={() => undefined} />
          </div>
          <div className="text-right">
            <p className="password-forget pointer">{t('Forgot password')}</p>
          </div>
        </div>
        <div className="down-buttons flex w-100 justify-between ">
          <Button
            onClick={() => userLogin()}
            style={{
              width: '100%',
              minHeight: '45px',
              background: `${emptyCrend ? '#E0FFF1' : '#5CD79E'}`,
              borderRadius: '23px',
              color: `${emptyCrend ? '#5CD79E' : '#E0FFF1'}`,
            }}
          >
            {t('Log in')}
          </Button>
        </div>
        <span className="err-mssg">{error !== null ? errMssg : ''}</span>
      </div>
    </div>
  );
};

export default Login;
